import {
  useColorMode,
  Switch,
  Flex,
} from '@chakra-ui/react'
import { MoonIcon, SunIcon } from '@chakra-ui/icons';

function ToggleThemeSwitch() {
  const { colorMode, toggleColorMode } = useColorMode()

  return (
    <Flex align="center">
      <SunIcon color={colorMode === 'light' ? 'orange.400' : 'gray.600'} mr={2} boxSize={4} />
      <Switch
        isChecked={colorMode === 'dark'}
        onChange={toggleColorMode}
        colorScheme="brand"
        size="md"
      />
      <MoonIcon color={colorMode === 'dark' ? 'blue.200' : 'gray.400'} ml={2} boxSize={4} />
    </Flex>
  );
}

export default ToggleThemeSwitch;